<script setup lang="ts">

</script>

<template>
  <div class="home-page container">
    <home-main />
  </div>
</template>

<style lang="scss">
.home-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 60px;

  @media (max-width: $breakpoint-xs) {
    gap: 38px;
  }
}
</style>
